import { useSidebar } from '@/app/providers/SidebarProvider';
import SidebarFull from './SidebarFull';
import SidebarRail from './SidebarRail';
import { useSidebarNav } from './useSidebarNav';

const ASIDE_MOTION =
    'transition-transform duration-300 ease-in-out lg:motion-safe:transition-[width] lg:motion-safe:duration-200 lg:motion-safe:ease-shell';

const AppSidebar: React.FC = () => {
    const { isMobileOpen, isRail } = useSidebar();
    const { groups, isActive, submenu, newQuote } = useSidebarNav();

    return (
        // lg:translate-none keeps the aside from becoming a containing block: the rail flyout is
        // position: fixed and must escape the aside's overflow-hidden.
        <aside
            className={`fixed mt-16 lg:mt-0 top-(--env-banner-height) bottom-0 left-0 z-50 flex flex-col overflow-hidden border-r border-mp-border bg-mp-surface text-mp-foreground w-72.5 ${
                isRail ? 'lg:w-22.5' : ''
            } ${isMobileOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-none ${ASIDE_MOTION}`}
        >
            {isRail ? (
                <SidebarRail groups={groups} isActive={isActive} newQuote={newQuote} />
            ) : (
                <SidebarFull
                    groups={groups}
                    isActive={isActive}
                    submenu={submenu}
                    showLogo={!isMobileOpen}
                    newQuote={newQuote}
                />
            )}
        </aside>
    );
};

export default AppSidebar;
